import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from 'react-isolated-scroll';
import { Translate } from 'react-redux-i18n';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';

import { fetchItemSalesHistory, fetchSalesOrderProductByID, fetchBatchesByID, fetchProductPromotion } from '../../actions/sales_actions';
import { fetchSalesOrderSuggestions } from '../../actions/autoSuggest_actions';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isJML, isSY } from '../../actions/root_url';

const isChinaTown = ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
const isHMM = ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/' || ROOT_URL === 'https://hmm-scm.truckxi.com/api/';
const isOCM = ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/'|| ROOT_URL === 'https://ocm-scm.truckxi.com/api/';
const isTN = ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || ROOT_URL === "https://tn-scm.truckxi.com/api/";

/* ----------- */
/*    Utils    */
/* ----------- */

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/* --------------- */
/*    Component    */
/* --------------- */

class SalesOrderAutoSuggest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      suggestions: [],
      CustomerNumber: null,
      noSuggestions: false,
    };

    this.lastRequestId = null;
    this.onSuggestionsFetchRequested = _.throttle(({ value }) => {
      this.loadSuggestions(value);
    }, 200);
  }

  componentWillMount() {
    let CustomerNumber = this.props.CustomerNumber;
    if (this.props.CustomerNumber && this.props.CustomerNumber.value) {
      CustomerNumber = this.props.CustomerNumber.value;
    }
    this.setState({ CustomerNumber });
  }

  componentWillReceiveProps(nextProps) {
    const isInputBlank = nextProps.value === '';
    const noSuggestions = !isInputBlank && nextProps.salesOrderSuggestions.length === 0;
    this.setState({ noSuggestions });
    if (nextProps.CustomerNumber && nextProps.CustomerNumber !== this.props.CustomerNumber) {
      let CustomerNumber = nextProps.CustomerNumber;
      if (nextProps.CustomerNumber && nextProps.CustomerNumber.value) {
        CustomerNumber = nextProps.CustomerNumber.value;
      }
      this.setState({ CustomerNumber });
    }

    
    if (nextProps.salesOrderSuggestions !== this.props.salesOrderSuggestions) {
      this.setState({
        suggestions: [...(nextProps.salesOrderSuggestions).slice(0, 200)],
      });
      if (this.props.SearchType === 'Barcode' && nextProps.salesOrderSuggestions.length === 1) {
        // selectInventoryInfo get info
        // this.props.fetchSalesOrderProductByID(suggestion.Product_id, this.state.CustomerNumber);
        this.props.fetchSalesOrderProductByID(nextProps.salesOrderSuggestions[0].Product_id, this.state.CustomerNumber);
        // this.props.fetchSalesOrderProductByID(nextProps.salesOrderSuggestions[0].Product_id, this.state.CustomerNumber, this.props.Company_id);
        this.props.fetchItemSalesHistory(this.state.CustomerNumber, nextProps.salesOrderSuggestions[0].Product_id);
        this.props.handleFocusQty();
      }
    }
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onFocus(event) {
    event.target.select();
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    // function to get product here
    event.stopPropagation();
    event.preventDefault();
    // this.props.fetchSalesOrderProductByID(suggestion.Product_id, this.state.CustomerNumber, this.props.selectedCompany ? this.props.selectedCompany.value : null);
    this.props.fetchSalesOrderProductByID(suggestion.Product_id, this.state.CustomerNumber, this.props.Company_id, this.props.Pickup_Warehouse_id);
    (isTN || isJML) && this.props.fetchBatchesByID(suggestion.Product_id, isJML);
    this.props.fetchProductPromotion(suggestion.Product_id, this.props.Company_id, this.state.CustomerNumber);
    this.props.fetchItemSalesHistory(this.state.CustomerNumber, suggestion.Product_id);
    this.props.handleFocusQty();
  }

  onKeyPress = () => {
    return false;
    // this.props.handleKeyPress('quantity', event);
  }

  getSuggestionValue = (suggestion) => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return `${suggestion.ProductNO} | ${suggestion.Name}`;
      case 'RefNum':
        return `${suggestion.RefNum} | ${suggestion.Name}`;
      case 'Name':
        return suggestion.Name;
      case 'Description':
        return `${suggestion.Description} | ${suggestion.Name}`;
      case 'GeneralNum':
        return `${suggestion.GeneralNum} | ${suggestion.Name}`;
      default:
        return null;
    }
  }

  loadSuggestions(value) {
    // if (value.length < 3) {
    //   return;
    // }
    // Cancel the previous request
    // if (this.lastRequestId !== null) {
    //   clearTimeout(this.lastRequestId);
    // }

    // this.setState({
    //   isLoading: true,
    //   suggest: [],
    // });


    // Fake request
    // this.lastRequestId = setTimeout(() => {
    if (this.state.CustomerNumber == null) {
      return;
    }
    this.props.fetchSalesOrderSuggestions(this.state.CustomerNumber, this.props.SearchType, value, this.props.Group);
    // this.props.fetchSalesOrderSuggestions(this.state.CustomerNumber, this.props.SearchType, value, this.props.Company_id, this.props.Pickup_Warehouse_id);
  }

  renderErrorMessage() {
    const { noSuggestions } = this.state;
    if (noSuggestions && !this.props.salesOrderSuggestionsIsLoading) {
      return (
        <div className="no-suggestions">
          <Translate value="no_data_found" />
        </div>
      );
    }
    return <div />;
  }

  renderSearchTypeValue(suggestion) {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return suggestion.ProductNO;
      default:
        return suggestion.RefNum;
    }
  }

  renderSuggestion = (suggestion) =>
    <Row 
      className="suggestion"
      id="suggestion-render"
      className="sales-auto-suggest-suggestions"
      style={{ fontSize: isHMM ? '13px' : '15px' }} // style={isHMM ? { fontSize: '13px' } : {}}
    >
      <Col xs={(isHMM || isSY) ? 1 : 2}>
        {this.renderSearchTypeValue(suggestion)}
      </Col>
      {
        isSY && 
        <Col xs={2}>
          <img src={suggestion.Thumbnail} alt="Product image" />
        </Col>
      }
      <Col xs={isOCM ? 3 : (isHMM ? 2 : 4)}>
        {suggestion.Name}
      </Col>
      <Col xs={isOCM ? 2 : (isHMM ? 4 : 1)}>
        {suggestion.Description}
      </Col>
      <Col xs={1} id="price-col">
        {suggestion.Price}
      </Col>
      <Col xs={1} style={{ overflow: 'hidden' }}>
        {suggestion.MeasureUnit}
      </Col>
      <Col xs={1}>
        {suggestion.InStock}
      </Col>
      {
        !isSY && 
        <Col xs={1}>
          {suggestion.Purchased}
        </Col>
      }
      {
        !isSY && 
        <Col xs={1}>
          {suggestion.PreSale}
        </Col>
      }
    </Row>

  renderSearchTypeHeader = () => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return <Translate value="prod_num" />;
      default:
        return <Translate value="ref_num" />;
    }
  }

  renderSuggestionsContainer = ({ containerProps, children }) => {
    const { ref, ...restContainerProps } = containerProps;
    const callRef = scrollingDiv => {
      if (scrollingDiv !== null) {
        ref(scrollingDiv.component);
      }
    };

    return (
      <div {...restContainerProps} >
        <div className="container" style={{ width: '100%' }} id="suggestion-container">
          <Row style={{ padding: '10px 5px', margin: '0px' }} className="sales-auto-suggest-suggestions" id="sales-auto-suggest-header">
            <Col xs={(isHMM || isSY) ? 1 : 2}>
              {this.renderSearchTypeHeader()}
            </Col>
            {
              isSY &&
              <Col xs={2}>
                <Translate value="image" />
              </Col>
            }
            <Col xs={isOCM ? 3 : (isHMM ? 2 : 4)}>
              <Translate value="prod_name" />
            </Col>
            <Col xs={isOCM ? 2 : (isHMM ? 4 : 1)}>
              <Translate value="desc" />
            </Col>
            <Col xs={1} id="price-col">
              <Translate value="unit_dollarsign" />
            </Col>
            <Col xs={1} style={{ overflow: 'hidden' }}>
              <Translate value="pkg_type" />
            </Col>
            <Col xs={1}>
              <Translate value="instock" />
            </Col>
            {
              !isSY &&
              <Col xs={1}>
                <Translate value="purchased" />
              </Col>
            }
            {
              !isSY &&
              <Col xs={1}>
                <Translate value="presale" />
              </Col>
            }
          </Row>
        </div>
        <IsolatedScroll id="suggestions-customer-container" ref={callRef}>
          {children}
        </IsolatedScroll>
      </div>
    );
  }

  render() {
    const { suggestions } = this.state;
    const inputProps = {
      value: this.props.value,
      onChange: this.props.onChange,
      onKeyPress: this.onKeyPress,
      onFocus: this.onFocus,
      id: 'sales-auto-suggest',
    };
    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          focusInputOnSuggestionClick={false}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          renderSuggestionsContainer={this.renderSuggestionsContainer}
          onSuggestionSelected={this.onSuggestionSelected}
          highlightFirstSuggestion
          inputProps={inputProps}
        />
        {this.renderErrorMessage()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    salesOrderSuggestions: state.autoSuggest.salesOrderSuggestions,
    salesOrderSuggestionsIsLoading: state.autoSuggest.salesOrderSuggestionsIsLoading,
    salesOrderSuggestionsError: state.autoSuggest.salesOrderSuggestionsError,
    // selectedCompany: state.header.selectedCompany,
  };
}

export default connect(mapStateToProps, { fetchSalesOrderProductByID, fetchItemSalesHistory, fetchSalesOrderSuggestions, fetchBatchesByID, fetchProductPromotion })(SalesOrderAutoSuggest);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/SalesOrderAutoSuggest.jsx